import { fromJS } from 'immutable';

export default {
    setSupportUsers: (state, supportUsers) => {
        return state.setIn(['list'], fromJS(supportUsers)).set('initialized', true);
    }
};



// WEBPACK FOOTER //
// ./environments/logging/data/SupportUsers/core.js